import api from '@/api/referral'

const state = {

}

const actions = {
  startListReferral ({ commit }, { companyId, campaignShortId, micrositeShortId }) {
    return api.startListReferral(companyId, campaignShortId, micrositeShortId)
  },
  getJobReferralUrl: ({ commit }, { listReferralId, jobId }) => {
    return api.getJobReferralUrl(listReferralId, jobId)
  },
  getReferralShareQrCode (context, params) {
    return api.getReferralShareQrCode(params)
  },
  getReferralUploadedCandidateCount (context, params) {
    return api.getReferralUploadedCandidateCount(params)
  },
  getReferralRewardList (context, params) {
    return api.getReferralRewardList(params)
  },
  payReward (context, params) {
    return api.payReward(params)
  },
  createExportReferralRewardTask (context, params) {
    return api.createExportReferralRewardTask(params)
  },
  getReferralRewardExportTaskInfo (context, params) {
    return api.getReferralRewardExportTaskInfo(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
